import {Inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';
import {AuthService} from './auth.service';

@Injectable()
export class LoginPageGuard {

    constructor(
        private authService: AuthService,
        private router: Router,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(): boolean | UrlTree {
        const userRole = this.authService.userRole;

        if (!userRole) {
            return true;
        } else {
            const url = this.routeRedirects.DASHBOARD_ROUTES[userRole];

            return this.router.parseUrl(url);
        }

    }

    public canActivateChild(): boolean | UrlTree {
        return this.canActivate();
    }

}
